import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";

@Component
class NumberGenerator extends Vue {
  public getPriceFormat(price): string {
    if ( price === 0 ) {
      return "0"
    } else {
      return price.toLocaleString('ja-JP');
    }
  }
}

export default NumberGenerator;
